import React from "react";
import cn from "classnames";
import { NavLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import routing from "../../../routing";
import Icon from "../../../icon";

import { MobileMenu, StyledMenuItem } from "./styles";
import messages from "./messages";

const MenuItem = ({ display, to, navigate, action, children, isActive }:
    {
        to?: string;
        navigate: () => void;
        children: JSX.Element | JSX.Element[];
        display: boolean;
        isActive?: boolean;
        action?: () => void;
    }) => {
    if (!display) return null;
    return (
        <StyledMenuItem>
            {to && (
                <NavLink to={"/" + to} onClick={navigate} className={cn(isActive && "Active")}>
                    {children}
                </NavLink>
            )}
            {action && (
                <a
                    onClick={() => {
                        action();
                        navigate();
                    }}
                >
                    {children}
                </a>
            )}
        </StyledMenuItem>
    );
};

const NavMobile = ({
    user,
    loggedIn,
    admin,
    mobileMenuOpen,
    navigate,
    logout,
    isLogin,
    isPathDashboard,
    isPathHomeworks,
    isPathHomework,
    isPathBrowse,
    isModeration,
    isTranslate,
    isAccount,
    isPathHelp,
    isAboutUs,
    isTeachingSettings,
}: any) => (
    <MobileMenu show={mobileMenuOpen || undefined}>
        <MenuItem to={routing.browse} display navigate={navigate} isActive={isPathBrowse}>
            <Icon i="browse" />
            <FormattedMessage {...messages.browse} />
        </MenuItem>

        <MenuItem to={routing.dashboard} display={loggedIn} navigate={navigate} isActive={isPathDashboard}>
            <Icon i="dashboard" />
            <FormattedMessage {...messages.editor} />
        </MenuItem>
        <MenuItem to={routing.classes} display={loggedIn} navigate={navigate} isActive={isPathHomeworks}>
            <Icon i="whiteboard" style={{ marginTop: 3 }} />
            <FormattedMessage {...messages.classes} />
        </MenuItem>

        <MenuItem to={routing.homework} display={!loggedIn} navigate={navigate} isActive={isPathHomework}>
            <Icon i="homework" />
            <FormattedMessage {...messages.homework} />
        </MenuItem>

        <MenuItem to={routing.join} display={!loggedIn} navigate={navigate}>
            <Icon i="whiteboard" style={{ marginTop: 3 }} />
            <FormattedMessage {...messages.join} />
        </MenuItem>

        <MenuItem to={routing.aboutUs} display navigate={navigate} isActive={isAboutUs}>
            <Icon i="aboutus" />
            <FormattedMessage {...messages.aboutUs} />
        </MenuItem>

        <MenuItem to={routing.help} display navigate={navigate} isActive={isPathHelp}>
            <Icon i="help" />
            <FormattedMessage {...messages.help} />
        </MenuItem>

        <MenuItem to={routing.signup} display={!loggedIn} navigate={navigate}>
            <Icon i="signup" />
            <FormattedMessage {...messages.registration} />
        </MenuItem>

        <MenuItem to={routing.login} display={!loggedIn} navigate={navigate} isActive={isLogin}>
            <Icon i="login" />
            <FormattedMessage {...messages.login} />
        </MenuItem>

        <MenuItem
            to={routing.translate}
            display={loggedIn && user.isTranslator}
            navigate={navigate}
            isActive={isTranslate}
        >
            <Icon i="translate" />
            <FormattedMessage {...messages.translate} />
        </MenuItem>

        <MenuItem
            to={admin ? routing.moderation + "/users" : routing.testModeration}
            display={(admin || (user.moderator && user.moderator.accepted)) && loggedIn}
            navigate={navigate}
            isActive={isModeration}
        >
            <Icon i="admin" />
            <FormattedMessage {...messages.moderation} />
        </MenuItem>

        <MenuItem to={routing.account} display={loggedIn} navigate={navigate} isActive={isAccount}>
            <Icon i="account" />
            <FormattedMessage {...messages.account} />
        </MenuItem>
        <MenuItem to={routing.teachingSettings} display={loggedIn} navigate={navigate} isActive={isTeachingSettings}>
            <Icon i="settings" />
            <FormattedMessage {...messages.teachingSettings} />
        </MenuItem>

        <MenuItem action={logout} display={loggedIn} navigate={navigate}>
            <Icon i="logout" />
            <FormattedMessage {...messages.logout} />
        </MenuItem>
    </MobileMenu>
);

export default NavMobile;
